export default __webpack_public_path__ + "static/media/mainBackground.46e75160.png";